import { mockComponent } from 'bloko/common/setupMockComponents';

export { default as ControlGroupItem } from './ControlGroupItem';

export default mockComponent('ControlGroup', null, { withChildren: true });
